import { BaseService } from './core/BaseService';

export interface KeyEntry {
  id: string;
  provider: string;
  keySuffix?: string;
  label?: string;
  created_at?: string;
}

export interface StoreKeyPayload {
  provider: string;
  key: string;
}

class KeysApiService extends BaseService {
  async listKeys(): Promise<KeyEntry[]> {
    const data = await this.get<{ keys?: KeyEntry[] }>('/api/keys');
    return data?.keys ?? [];
  }

  async addKey(entry: StoreKeyPayload): Promise<void> {
    await this.post('/api/keys', entry);
  }
}

export const keysApi = new KeysApiService();
